import React from 'react'
import {
  ModalBody,
  ShareButtonCircle,
  Modal
} from './ProductDetailsModalStyledComponents'
import ShareButton from '../../SocialShare/ShareButton'
import ProductDetails from '../../ProductDetails/ProductDetails'
import ProductModel from '../../../../api/models/Product'
import { matchBreakpoint } from 'ui/rwd'
import CloseButton from '../../CloseButton/CloseButton'

interface Props {
  isOpen: boolean,
  toggle: () => void,
  product: ProductModel,
  storeId: string
}

export default function ProductDetailsModal(props: Props) {
  return (
    <Modal
      centered={matchBreakpoint('sm')}
      size='lg'
      isOpen={props.isOpen}
      toggle={props.toggle}
      className='product-details'
    >
      <CloseButton {...{ toggle: props.toggle }} />
      <ShareButton
        itemUrl={props.product.getOwnUrl(props.storeId)}
        itemName={props.product.getName()}
        description={props.product.getDescription()}
        itemId={props.product.getId()}
        socialPhotos={props.product.getImages()}
        vertical
      >
        <ShareButtonCircle />
      </ShareButton>

      <ModalBody className='d-sm-inline-flex p-0'>
        <ProductDetails product={props.product} storeId={props.storeId} handleClose={props.toggle} />
      </ModalBody>
    </Modal>
  )
}